import { render, staticRenderFns } from "./PlatformWaitSettle.vue?vue&type=template&id=6ea15abe&scoped=true&"
import script from "./PlatformWaitSettle.vue?vue&type=script&lang=js&"
export * from "./PlatformWaitSettle.vue?vue&type=script&lang=js&"
import style0 from "./PlatformWaitSettle.vue?vue&type=style&index=0&id=6ea15abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea15abe",
  null
  
)

export default component.exports